import { render, staticRenderFns } from "./DinamicReward.vue?vue&type=template&id=1ce4f881&scoped=true"
import script from "./DinamicReward.vue?vue&type=script&lang=js"
export * from "./DinamicReward.vue?vue&type=script&lang=js"
import style0 from "./DinamicReward.vue?vue&type=style&index=0&id=1ce4f881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce4f881",
  null
  
)

export default component.exports